"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BreadcrumbHelper = _interopRequireDefault(require("../../util/BreadcrumbHelper"));

var _KycDashboardModel = _interopRequireDefault(require("./models/KycDashboardModel"));

var _Widget = _interopRequireDefault(require("./components/Widget"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var KYCDashboard = /*#__PURE__*/function (_Component) {
  _inherits(KYCDashboard, _Component);

  function KYCDashboard(props) {
    var _this;

    _classCallCheck(this, KYCDashboard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KYCDashboard).call(this, props));
    _this.state = {
      newToday: '',
      newLastWeek: '',
      newLastMonth: '',
      resolvedToday: '',
      resolvedLastWeek: '',
      resolvedLastMonth: '',
      failedToday: '',
      failedLastWeek: '',
      failedLastMonth: ''
    };

    _BreadcrumbHelper["default"].setCrumbs([{
      label: 'KYC'
    }]);

    return _this;
  }

  _createClass(KYCDashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._loadData();
    }
  }, {
    key: "_loadData",
    value: function () {
      var _loadData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var silent,
            kycData,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                silent = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                _context.next = 3;
                return new _KycDashboardModel["default"]().getKycStats();

              case 3:
                kycData = _context.sent;

                try {
                  this.setState({
                    newToday: kycData["new"].today,
                    newLastWeek: kycData["new"].lastWeek,
                    newLastMonth: kycData["new"].lastMonth,
                    resolvedToday: kycData.resolved.today,
                    resolvedLastWeek: kycData.resolved.lastWeek,
                    resolvedLastMonth: kycData.resolved.lastMonth,
                    failedToday: kycData.failed.today,
                    failedLastWeek: kycData.failed.lastWeek,
                    failedLastMonth: kycData.failed.lastMonth
                  });
                } catch (e) {
                  console.log(e);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _loadData() {
        return _loadData2.apply(this, arguments);
      }

      return _loadData;
    }()
  }, {
    key: "render",
    value: function render() {
      var newTotal = this.state.newToday + this.state.newLastWeek + this.state.newLastMonth;
      var resolvedTotal = this.state.resolvedToday + this.state.resolvedLastWeek + this.state.resolvedLastMonth;
      var failedTotal = this.state.failedToday + this.state.failedLastWeek + this.state.failedLastMonth;
      return _react["default"].createElement("div", {
        className: "dashboard-management"
      }, _react["default"].createElement("h1", null, _react["default"].createElement("i", {
        className: "fa fa-tachometer",
        "aria-hidden": "true"
      }), " KYC Dashboard"), _react["default"].createElement("div", {
        className: "main-inner"
      }, _react["default"].createElement(_Widget["default"], {
        title: 'New KYC Requests',
        subtitle: 'total new KYC requests',
        total: newTotal,
        today: this.state.newToday,
        lastWeek: this.state.newLastWeek,
        lastMonth: this.state.newLastMonth
      }), _react["default"].createElement(_Widget["default"], {
        title: 'Resolved KYC Requests',
        subtitle: 'total resolved KYC requests',
        total: resolvedTotal,
        today: this.state.resolvedToday,
        lastWeek: this.state.resolvedLastWeek,
        lastMonth: this.state.resolvedLastMonth
      }), _react["default"].createElement(_Widget["default"], {
        title: 'Failed KYC Requests',
        subtitle: 'total failed KYC requests',
        total: failedTotal,
        today: this.state.failedToday,
        lastWeek: this.state.failedLastWeek,
        lastMonth: this.state.failedLastMonth
      })));
    }
  }]);

  return KYCDashboard;
}(_react.Component);

exports["default"] = KYCDashboard;